import { render, staticRenderFns } from "./ShareLocation.vue?vue&type=template&id=2ed68fa1&scoped=true&"
import script from "./ShareLocation.vue?vue&type=script&lang=js&"
export * from "./ShareLocation.vue?vue&type=script&lang=js&"
import style0 from "./ShareLocation.vue?vue&type=style&index=0&id=2ed68fa1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed68fa1",
  null
  
)

export default component.exports